import {Card, Box, Typography, useTheme, Link, Skeleton} from '@mui/material';
import {Image} from '@jobseeker/lotus/components/Image';
import {CTAProps} from '../type';
import {ChevronRight} from '@jobseeker/lotus/icons';
import {GraduationHat} from '@jobseeker/lotus/images';
import {openUrl} from '@jobseeker/common-core/utils/common';
import {useState, useEffect} from 'react';

export default ({children, cardSxProps = {}, ...props}: CTAProps) => {
  const [showSkeleton, setShowSkeleton] = useState(true);

  useEffect(() => {
    setShowSkeleton(false);
  }, []);

  return showSkeleton ? (
    <Card
      sx={{
        p: 2,
        borderRadius: 4,
        position: 'relative',
        ...cardSxProps,
      }}
    >
      <Skeleton variant="rounded" width="100%" height={80} />
    </Card>
  ) : (
    <Card
      sx={{
        p: 2,
        borderRadius: 4,
        position: 'relative',
        ...cardSxProps,
      }}
    >
      <Typography
        component={'p'}
        color={'text.secondary'}
        variant="subtitle3"
        sx={{mb: 0}}
      >
        {props.subTitle}
      </Typography>
      <Typography variant="subtitle2" component="p" sx={{mb: 0.5}}>
        {props.title}
      </Typography>
      <Link
        onClick={(e) => {
          e.preventDefault();
          props?.onClick?.();
          setTimeout(() => {
            if (props.actionUrl) openUrl(props.actionUrl, '_blank');
          }, 0);
        }}
        href={props.actionUrl}
        target="_blank"
        sx={{
          textDecoration: 'none',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Typography variant="subtitle3">{props.actionLabel}</Typography>
        <Box component={'span'} sx={{mx: '2px'}}>
          <Image
            src={ChevronRight}
            alt={'Arrow'}
            width={10}
            height={10}
            objectFit="cover"
          />
        </Box>
      </Link>
      {!!props.imageUrl && (
        <Box sx={{position: 'absolute', bottom: -8, right: 0}}>
          <Image
            src={props.imageUrl ?? GraduationHat}
            alt={'Arrow'}
            width={60}
            height={50}
            layout="contained"
            objectFit="contained"
          />
        </Box>
      )}
    </Card>
  );
};
